import { createContext, MouseEvent } from 'react'
import { Opportunity } from 'src/interfaces/opportunity'

export interface IOpportunitiesTableContext {
  refreshOpportunities(): void

  actionAnchor: null | HTMLElement
  opportunityToAction: Opportunity | null
  openOpportunityItemAction(event: MouseEvent<HTMLButtonElement>, opportunity: Opportunity): void
  closeOpportunityItemAction(): void
  clearOpportunityToAction(): void
}

export const OpportunitiesTableContext = createContext<IOpportunitiesTableContext>({
  refreshOpportunities: () => {},

  actionAnchor: null,
  opportunityToAction: null,
  openOpportunityItemAction: () => {},
  closeOpportunityItemAction: () => {},
  clearOpportunityToAction: () => {},
})
